import {Server } from '@sai/protocol';
import RecordUtils from './utils/RecordUtils';
import ConfigUtils from './utils/ConfigUtils';
import I18NUtils from './utils/I18NUtils';
import ResetPasswordRequest from './requests/ResetPasswordRequest';
import ErrorUtils from './utils/ErrorUtils';

Server.initialize({
    serverUrl: location.origin + ConfigUtils.getRelativePath(),
    deviceType: 'web',
    callbacks: {
      sessionTimeoutCallback: undefined,
      globalFailureCallback: (error:any) => {},
      missingAuthCallback: (message: any, resolve: any, reject: any) => {
          reject('There shouldn\'t be any require authentication');
      },
      ongoingMessageCallback: undefined,
      displayMessageCallback: undefined,
      i18NEntryCallback: (code: string) => I18NUtils.getMessage(code, 'fr', {})
    },
    timeout: 0
  });

let resetBtn = $('#reset-btn');

window['recaptchaCallback'] = function () {
    resetBtn.prop('disabled', false);
    resetBtn.addClass('tada');
};

window['recaptchaErrorCallback'] = function () {
    resetBtn.prop('disabled', true);
    resetBtn.removeClass('tada');
}

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email)
};

declare var grecaptcha: any;
$(document).ready(function (){
    let lang = $('html').attr('lang').toUpperCase() || 'FR';
    let form = $('form');
    let askForReset = () => {
        if (resetBtn.is(':disabled')) {
            $('.invalid-captcha').show();
            return false;
        }
        resetBtn.removeClass('tada');
        let isOk = true;
        $('.invalid_input').hide();
        RecordUtils.startLoading(resetBtn);
        var emailInput = $('#login-email').val() as string
        if (isEmail(emailInput)) {
            var captcharesp = grecaptcha.getResponse()
            if (captcharesp.length == 0) {
                isOk = false;
                $('.invalid-captcha').show();
                $('html, body').animate({ scrollTop: $(document).height() - $(window).height() }, 500);
            }
        } else {
            isOk = false;
            $('.invalid-email').show();
        }

        if (!isOk) {
            RecordUtils.stopLoading(resetBtn);
            return false;
        }

        // calling server
        var email = $('#login-email').val() as string;
        var captcha_resp = grecaptcha.getResponse()
        let req = new ResetPasswordRequest(email, captcha_resp);
        Server.performRequest(req)
            .then((response) => {
                $('form, button, .header-message').hide();
                $('.mail-message').show();
                setTimeout(() => { location.href = '/'; }, 10000);
            })
            .catch((error) => {
                $('.server-error').html(ErrorUtils.getErrorDescription(error, lang));
                $('.server-error').show();
                RecordUtils.stopLoading(resetBtn);
            });
    }
    resetBtn.on('click', askForReset);
    form.on('submit', askForReset);

    $('#home-btn').on('click', () => {
        window.location.href = '/login';
    });
});